define('presentation/account/presentationObjects/billingEventsPresentationObject',[],function() {
    return function(){
        var self = this;
        self.billingEventDate = null;
        self.billingEventDescription = null;
    };
});

